module.exports = __webpack_public_path__ + "img/2.b5a39ee8.png";